import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { CircleQuestionMark } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import { HEADER_ACTION_BUTTON_SIZE } from "@/components/Header/Header.constants";

import { useHandler } from "./HelpButton.hooks";

const DELAY = 200;

export function HelpButton() {
  const { t } = useTranslation();
  const handleOnClick = useHandler();

  return (
    <Tooltip>
      <TooltipTrigger
        delay={DELAY}
        render={
          <Button
            data-test="help-button"
            onClick={handleOnClick}
            variant="ghost"
            size={HEADER_ACTION_BUTTON_SIZE}
            aria-label={t("help_center")}
          />
        }
      >
        <CircleQuestionMark className="size-4" />
      </TooltipTrigger>
      <TooltipContent>{t("help_center")}</TooltipContent>
    </Tooltip>
  );
}
